import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-seleccionar-tipo-uso',
  templateUrl: 'seleccionar-tipo-uso.component.html',
  standalone: true,
  imports: [MatDialogModule],
})
export class SeleccionarTipoUsoComponent {
  constructor(
    private _dialogRef: MatDialogRef<SeleccionarTipoUsoComponent>,
    // @Inject(MAT_DIALOG_DATA) private _data: any,
    private _router: Router,
  ) {}

  si(): void {
    this._router.navigate(['/perfil-facturacion']);
    this._dialogRef.close();
  }

  no(): void {
    this._dialogRef.close();
  }
}
